import DescriptionIcon from '@mui/icons-material/Description';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';

export default function ParentChatMessage(props: any) {
  const { backgroundColor, parentMessage, messagePosition } = props;
  const messageText = parentMessage?.label || parentMessage?.text;

  return <div className="ele-text-message-parent flex relative min-w-[150px] d-flex h-100  my-2 text-sm">
    <div className="ele-text-message-status-indicator w-[3px] rounded-[10px] scroll-my-3 mr-1 py-5"
      style={{ backgroundColor }}></div>
    <div className={`ele-text-message-content rounded-xl py-2 px-4 bg-primaryColor break-words overflow-hidden truncate w-full ${messagePosition === 'right' ? 'text-white' : ''}`}
      style={{ backgroundColor }} title={messageText}>
      <p className="ele-text-message-sender m-0 opacity-70">{parentMessage?.messagedBy || 'you'}</p>
      <div className="ele-text-media-container-sender flex justify-start items-center">
        {(parentMessage?.medias && parentMessage?.medias[0] && parentMessage?.medias[0].type === 'image') &&
          <>
            <img className="ele-image-container-sender" alt='parent-reply' src={parentMessage?.medias[0]?.url} width="40" height="40" />
            <p className="ele-image-caption-container-sender mb-0 ml-2">photo</p>
          </>
        }
        {(parentMessage?.medias && parentMessage?.medias[0] && parentMessage?.medias[0].type === 'video') &&
          <>
            <video className="ele-video-container-sender" src={parentMessage?.medias[0]?.url} width="40" height="40" />
            <p className="ele-video-caption-container-sender mb-0 ml-2">video</p>
          </>
        }
        {(parentMessage?.medias && parentMessage?.medias[0] && parentMessage?.medias[0].type === 'document') &&
          <>
            <DescriptionIcon
              fontSize="medium"
              id="description-icon"
              aria-haspopup="true"
            />
            <p className="ele-document-caption-container-sender mb-0 ml-2">document</p>
          </>
        }
        {(parentMessage?.medias && parentMessage?.medias[0] && parentMessage?.medias[0].type === 'audio') &&
          <>
            <AudiotrackIcon
              fontSize="medium"
              id="audiotrackIcon-icon"
              aria-haspopup="true"
            />
            <p className="ele-video-caption-container-sender mb-0 ml-2">audio</p>
          </>
        }
      </div>
      {(messageText && (!parentMessage?.medias || !parentMessage?.medias.length)) &&
        <>
          {messageText}
        </>
      }
    </div>
  </div>
}
